import { createI18n } from "vue-i18n";
import ar from "./src/locales/ar.json";
import en from "./src/locales/en.json";
import cn from "./src/locales/cn.json";
import de from "./src/locales/de.json";
import fr from "./src/locales/fr.json";
import se from "./src/locales/se.json";
import ch from "./src/locales/ch.json";

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("TASIS:LANG") || "ar",
  fallbackLocale: "ar",
  messages: {
    en,
    ar,
    cn,
    de,
    fr,
    se,
    ch,
  },
});

export default i18n;
